import { Link } from "react-router-dom";
import { Title, Button } from "../Object";
import { Grid } from "../Layout";

const Banner = () => {
  const gridProps = {
    row: {
      dir: 'row',
      layout: '100%', 
      size: '100%',
      gap: ['118px', '48px'],
    }
  }
  return (
    <>
      <div className="p-banner__wrap">
        <div className="l-row">
          <div className="p-banner__wrap--inner">
            <Link to="/recruit/">
              <div className="p-banner__content" data-state="recruit">
                <Grid {...gridProps.row}>
                  <Title slug="recruit" type="white"></Title>
                  <object>
                    <Button type="white" slug="recruit"></Button>
                  </object>
                </Grid>
              </div>
            </Link>
            <Link to="/about/">
              <div className="p-banner__content" data-state="about">
                <Grid {...gridProps.row}>
                  <Title slug="about-banner" type="white"></Title>
                  <object>
                    <Button type="white" slug="about"></Button>
                  </object>
                </Grid>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
